export { Strong } from './Strong';

export type { StrongProps } from './Strong';
